/* eslint-disable @typescript-eslint/naming-convention */
import { FeatureFlag } from '@ps/web-core-enums';
import { DebugKey, createDebug } from '@ps/web-core-utils';
import type { paths } from '@ps/web-shared-api-types/FeatureFlags';
import * as Sentry from '@sentry/react';
import { isEmpty, reduce } from 'lodash';

import { createClient } from '../../api/createClient';
import type { EffectParams } from '../../types';

import type { Feature } from './feature';

const effects = {
  async check(_payload: undefined, { dispatch, request }: EffectParams) {
    const { body } = await request<Feature>({
      service: 'features.check',
      body: { features: Object.values(FeatureFlag) }
    });
    dispatch.feature.update(body);
  },
  async checkKong(_payload: undefined, { rootState, select, store }: EffectParams) {
    const flags = select.feature.get(rootState);
    if (select.feature.check(rootState, FeatureFlag.IdpSecondaryLoginEnabled)) {
      const client = createClient<paths>(store);
      client
        .POST('/features', {
          params: { header: {} },
          body: { flags: Object.values(FeatureFlag) }
        })
        .then(({ data, error }) => {
          if (data) {
            const diff = reduce(
              data,
              (res: Feature, { flag, value }) =>
                value !== flags[flag as keyof Feature]
                  ? { ...res, [flag as keyof Feature]: value }
                  : res,
              {}
            );
            if (!isEmpty(diff))
              Sentry.captureMessage(`Feature flags are different: ${diff}`, 'warning');
            // resKong is just for comparison and fall back to SW atm.
          } else {
            throw new Error(JSON.stringify(error));
          }
        })
        .catch((error) => createDebug(DebugKey.Error)(`Kong feature flag call failed: ${error}`));
    }
  }
};

export default effects;
